import React from 'react'
import moment from 'moment'
import numeral from 'numeral'
import { Table, Divider, Tag } from 'antd'
import { Link } from 'react-router-dom'

import './shared.css'

const ListAriaV2Proposals = (props) => {
    const { data, loading, count, page, pageChangeHandler } = props

    const columns = [
        {
            title: 'Date',
            dataIndex: 'proposalDate',
            key: 'proposal_date',
            render: (proposalDate) =>
                moment.utc(proposalDate).format('MM/DD/YYYY'),
        },
        {
            title: 'Customer',
            dataIndex: 'clientName',
            key: 'customer__last_name',
        },
        {
            title: 'Age',
            dataIndex: 'clientAge',
            key: 'customer__age',
            align: 'right',
        },
        {
            title: 'Gender',
            dataIndex: 'clientGender',
            key: 'customer__gender',
        },
        {
            title: 'Index Rate',
            dataIndex: 'indexCreditingRate',
            key: 'index_crediting_rate',
            render: (value) => numeral(value / 100).format('0,000.00%'),
            align: 'right',
        },
        {
            title: 'Initial Face Amount',
            dataIndex: 'initialFaceAmount',
            key: 'initial_face_amount',
            render: (initialFaceAmount) =>
                numeral(initialFaceAmount).format('0,000'),
            align: 'right',
        },
        {
            title: 'Qualified',
            dataIndex: 'qualified',
            render: (qualified) => (
                <span>
                    <Tag color={qualified ? 'green' : 'red'} key={qualified}>
                        {qualified ? 'Yes' : 'No'}
                    </Tag>
                </span>
            ),
        },
        {
            title: 'Qualified Funds',
            dataIndex: 'qualifiedFundsAmount',
            key: 'qualified_funds_amount',
            render: (value) => numeral(value).format('0,000'),
            align: 'right',
        },
        {
            title: 'Federal Tax',
            dataIndex: 'federalTaxRate',
            key: 'federal_tax_rate',
            render: (value) => numeral(value / 100).format('0,000.00%'),
            align: 'right',
        },
        {
            title: 'State Tax',
            dataIndex: 'stateTaxRate',
            key: 'state_tax_rate',
            render: (value) => numeral(value / 100).format('0,000.00%'),
            align: 'right',
        },
        {
            title: 'Agent',
            dataIndex: 'agentName',
            key: 'agent_name',
        },
        {
            title: 'Last Modified',
            dataIndex: 'modifiedOn',
            key: 'modified_on',
            render: (modifiedOn) =>
                moment.utc(modifiedOn).format('MM/DD/YYYY LT'),
            sorter: (a, b) => a.modifiedOn.length - b.modifiedOn.length,
        },
        {
            title: 'Action',
            key: 'original',
            render: (original, record) => (
                <span>
                    <Link to={'/aria-v2/' + original.id}>View</Link>
                    <Divider type="vertical" />
                    <Link to={'/aria-v2/edit/' + original.id}>Edit</Link>
                </span>
            ),
        },
    ]

    const curr_pagination = {
        position: 'bottom',
        current: page + 1,
        defaultPageSize: 25,
        total: count,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['25', '50', '100'],
    }

    return (
        <div>
            <Table
                loading={loading}
                rowKey="id"
                pagination={curr_pagination}
                onChange={pageChangeHandler}
                columns={columns}
                rowClassName={(record, index) => {
                    return (index + 1) % 2 === 0 ? 'table-alt-row' : ''
                }}
                dataSource={data}
            />
        </div>
    )
}

export default ListAriaV2Proposals
